"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "fiumedinisi": {
    "bb05c231": [{
      "hkey": "da4149ee",
      "slug": "fiumedinisi",
      "name": "Fiumedinisi",
      "primary": true,
      "skipSearch": false
    }],
    "acqua-rossa-belvedere-buticari": [{
      "hkey": "da4149ee",
      "slug": "fiumedinisi",
      "name": "Fiumedinisi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "a23259de": [{
      "hkey": "da4149ee",
      "slug": "fiumedinisi",
      "name": "Fiumedinisi",
      "primary": true,
      "skipSearch": false
    }],
    "armo-carmine": [{
      "hkey": "da4149ee",
      "slug": "fiumedinisi",
      "name": "Fiumedinisi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "bf60f0cf": [{
      "hkey": "da4149ee",
      "slug": "fiumedinisi",
      "name": "Fiumedinisi",
      "primary": true,
      "skipSearch": false
    }],
    "badessa-paluci-intera": [{
      "hkey": "da4149ee",
      "slug": "fiumedinisi",
      "name": "Fiumedinisi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "12261389": [{
      "hkey": "da4149ee",
      "slug": "fiumedinisi",
      "name": "Fiumedinisi",
      "primary": true,
      "skipSearch": false
    }],
    "cancillo-pedaria-santissima": [{
      "hkey": "da4149ee",
      "slug": "fiumedinisi",
      "name": "Fiumedinisi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "41da4c79": [{
      "hkey": "da4149ee",
      "slug": "fiumedinisi",
      "name": "Fiumedinisi",
      "primary": true,
      "skipSearch": false
    }],
    "contrade-croce-motta": [{
      "hkey": "da4149ee",
      "slug": "fiumedinisi",
      "name": "Fiumedinisi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "dbc9df0d": [{
      "hkey": "da4149ee",
      "slug": "fiumedinisi",
      "name": "Fiumedinisi",
      "primary": true,
      "skipSearch": false
    }],
    "manti-richisi-cardonia": [{
      "hkey": "da4149ee",
      "slug": "fiumedinisi",
      "name": "Fiumedinisi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "d8d2833f": [{
      "hkey": "da4149ee",
      "slug": "fiumedinisi",
      "name": "Fiumedinisi",
      "primary": true,
      "skipSearch": false
    }],
    "matrice": [{
      "hkey": "da4149ee",
      "slug": "fiumedinisi",
      "name": "Fiumedinisi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "ea36415d": [{
      "hkey": "da4149ee",
      "slug": "fiumedinisi",
      "name": "Fiumedinisi",
      "primary": true,
      "skipSearch": false
    }],
    "misericordia-vecchio": [{
      "hkey": "da4149ee",
      "slug": "fiumedinisi",
      "name": "Fiumedinisi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "771be095": [{
      "hkey": "da4149ee",
      "slug": "fiumedinisi",
      "name": "Fiumedinisi",
      "primary": true,
      "skipSearch": false
    }],
    "padomeno-deni-marraro": [{
      "hkey": "da4149ee",
      "slug": "fiumedinisi",
      "name": "Fiumedinisi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "c3cd6983": [{
      "hkey": "da4149ee",
      "slug": "fiumedinisi",
      "name": "Fiumedinisi",
      "primary": true,
      "skipSearch": false
    }],
    "puntaleddu-fontana": [{
      "hkey": "da4149ee",
      "slug": "fiumedinisi",
      "name": "Fiumedinisi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "b2d25c7a": [{
      "hkey": "da4149ee",
      "slug": "fiumedinisi",
      "name": "Fiumedinisi",
      "primary": true,
      "skipSearch": false
    }],
    "san-francesco-ruagrande": [{
      "hkey": "da4149ee",
      "slug": "fiumedinisi",
      "name": "Fiumedinisi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "a972a13b": [{
      "hkey": "da4149ee",
      "slug": "fiumedinisi",
      "name": "Fiumedinisi",
      "primary": true,
      "skipSearch": false
    }],
    "san-pietro": [{
      "hkey": "da4149ee",
      "slug": "fiumedinisi",
      "name": "Fiumedinisi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "92c35491": [{
      "hkey": "da4149ee",
      "slug": "fiumedinisi",
      "name": "Fiumedinisi",
      "primary": true,
      "skipSearch": false
    }],
    "vacco-ramella-nuciara": [{
      "hkey": "da4149ee",
      "slug": "fiumedinisi",
      "name": "Fiumedinisi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;